import SelectableController from './SelectableController';

export default SelectableController;
